import { render, staticRenderFns } from "./NewCompany.vue?vue&type=template&id=7add2cc6"
import script from "./NewCompany.vue?vue&type=script&lang=js"
export * from "./NewCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports